import { render } from "./CriticalPatientsChart.vue?vue&type=template&id=575c770c&ts=true"
import script from "./CriticalPatientsChart.vue?vue&type=script&lang=ts"
export * from "./CriticalPatientsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__